import { useEffect, useRef, useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import globalStore from '@/store/global';
import InfiniteScroll from 'react-infinite-scroll-component';
import userStore from '@/store/user';
import chatStoreManager from '@/store/chat/manager';
import CompositionInput from '../composition-input';
import { SVGPureIcon } from '@/ui';
import Store from './store';
import './index.scss';
import tti_icon from '@/assets/img/tti_icon.png';
import Tooltip from '@/ui/tooltip';
import agentPageStore from '@/pages/agent-home/store';

const supportMultiple = false;
let maxChoice = 6;
const ListItem = ({
  modelSearchStore,
  item,
  isModal,
  multiple,
  onSucc,
  onClose,
  currentList,
}) => {

  const [isShowTooltip, setIsShowTooltip] = useState(false);
  const titleDOMRef = useRef(null);

  useEffect(() => {
    const element = titleDOMRef.current;
    if (element) {
      setIsShowTooltip(element.scrollWidth > element.clientWidth);
    }
  }, [item.title, titleDOMRef])

  const isCur = currentList.includes(item.id);
  return (
    <div
      onClick={evt => {
        if(item.tag == "ai_agent"){
          userStore.doWhenLogin(() => {
            agentPageStore.gotoAgentChat(item.id);
          });
          return;
        }
        if(isModal && isCur) return;
        if (isModal) {
          if (multiple) {
            const isChoiced = modelSearchStore.choiceList.some(
              _item => item.id == _item.id
            );
            if (!isChoiced) {
              if (modelSearchStore.choiceList.length >= maxChoice) return;
            }
            modelSearchStore.toggleChoice(item, isChoiced);
            onSucc && onSucc(modelSearchStore.choiceList);
          } else {
            onSucc && onSucc(item);
            onClose && onClose();
          }
        } else {
          chatStoreManager.newChat({ type: 10, asstId: item.id });
        }
      }}
      className={[
        'flex items-center relative',
        isCur ? 'cursor-not-allowed' : 'cursor-pointer',
        isModal ? '' : 'rounded-16px',
        isModal ? 'px-24px pt-15px pb-16px' : 'py-16px px-16px ',
        isModal ? '!hover:bg-[rgba(0,0,0,0.03)]' : 'hover:bg-gray-nav-hover bg-gray-nav',
        globalStore.isDark && !isModal ? 'bg-[#31313A]' : '',
      ]}
      data-id={item.id}
    >
      {isModal ? (
        <div className={["h-1px absolute left-24px right-24px bottom-0", globalStore.isDark ? 'bg-[rgba(255,255,255,0.04)]' : 'bg-[rgba(0,0,0,0.04)]']}></div>
      ) : null}
      <div
        className={[
          `relative overflow-hidden mr-16px flex-shrink-0`,
          isModal ? 'size-40px rounded-10px' : 'size-48px rounded-14px',
        ]}
      >
        <img
          src={item.icon || 'https://p1.ssl.qhimg.com/t110b9a93018295fdd8f951fb2c.png'}
          className={[
            'object-cover',
            'border-1px border-solid border-[rgba(0,0,0,0.1)]',
            isModal ? 'size-40px rounded-full' : 'size-48px rounded-14px',
            item.conversation_type == 1 ? 'border-1px border-[rgba(0,0,0,0.1)]':'',
          ]}
          alt=""
        />
        {item.conversation_type == 1 ? (
          <img
            className={[
              isModal ? 'size-17px' : 'size-20px',
              'object-cover absolute left-0 bottom-0',
            ]}
            src={tti_icon}
          />
        ) : null}
      </div>
      <div className="flex-grow w-0">
        <div
          className={[
            isModal ? 'text-16px leading-22px' : 'text-18px leading-25px',
            'text-primary font-medium truncate',
            isModal ? 'mb-2px' : 'mb-4px',
            'flex items-center',
          ]}
        >
           <Tooltip title={item.title} zIndex={isShowTooltip ? 1 : -100} trigger='hover'>
            <span className='flex-1 w-0 truncate' ref={titleDOMRef}>
              {item.title}
            </span>
          </Tooltip>
          {
            item?.localModel ? (
            <span className="w-36px height-18px leading-20px text-12px text-center text-[#0058FF] bg-[#DCEAFE] rounded-4px inline-block ml-5px">本地</span>
            ) : null
          }
          {
            item?.chat_type === 100 && item?.model_type === 2 ? (
            <span className="w-36px height-18px leading-20px text-12px text-center text-[#C77FCB] bg-opacity-10 bg-[#C77FCB] rounded-4px inline-block ml-5px">API</span>
            ) : null
          }
          {
            item?.chat_type === 100 && item?.model_type === 3 ? (
            <span className="w-36px height-18px leading-20px text-12px text-center text-[#ffffff] bg-[#FF9C07] rounded-4px inline-block ml-5px">私有</span>
            ) : null
          }
        </div>
        <div
          className={[
            'text-primary-opacity truncate',
            isModal
              ? 'text-12px leading-17px text-opacity-60'
              : 'text-14px leading-22px text-opacity-70',
          ]}
        >
          {item.description || item.greeting}
        </div>
      </div>
      {/* {isModal &&
          //(multiple || isCur) &&
          (isChoiced || isCur || modelSearchStore?.choiceList?.length < maxChoice) ? (
            <div
              className={[
                'gradient-btn-bg rounded-16px text-white text-14px font-medium p-0px ml-24px',
                'w-76px h-32px vh-center self-center select-none',
                // isChoiced || isCur ? 'p-1px' : '',
              ]}
              style={{
                padding: isChoiced || isCur ? 1 : 0,
              }}
            >
              {isChoiced || isCur ? (
                <div className="gradient-text-bg size-full bg-white rounded-16px">
                  <div className="gradient-text size-full vh-center">{isCur ? '当前' : '移除'}</div>
                </div>
              ) : (
                '选择'
              )}
            </div>
          ) : null} */}
    </div>
  );
};

const ModelSearch = observer(props => {
  const modelSearchStore = useLocalObservable(() => new Store());
  const {
    scene,
    className = '',
    multiple = false,
    title,
    filterList = [],
    currentList = [],
    maxChoices = 6,
    _scene = '',
    _filterList = [],
    simple = false,
    searchUrl
  } = props;

  const _multiple = supportMultiple ? multiple : false;

  useEffect(() => {
    modelSearchStore.filterList = filterList
  }, [filterList])

  useEffect(() => {
    maxChoice = maxChoices
  }, [maxChoices])

  const assistantModelTag = [
    { key: '', order: '9999', title: '全部' },
    ...(globalStore.cloudConfig.assistantModelTag || []),
  ].sort((a, b) => b.order - a.order);

  let {
    list: listData,
    npt,
    tag,
    tagList,
    wd,
    choiceList,
    setWd,
    getTag,
    getList,
    getListByTag,
  } = modelSearchStore;

  listData = (listData || [])?.filter(item => {
    return !_filterList?.find(_item => item.id == _item.id)
  })

  const isModal = scene == 'modal';

  const handleInputChange = val => {
    setWd(val);
    getList(true, scene, _scene, simple, searchUrl);
  };

  useEffect(() => {
    getList(true, scene, _scene, simple, searchUrl);
    getTag()
    console.log(assistantModelTag)
  }, [_scene]);

  return (
    <div className={['flex flex-col', className]}>
      <div className={[isModal ? 'px-24px' : '']}>
        <div
          className={[
            isModal ? 'text-24px leading-33px' : 'text-28px leading-40px',
            'text-primary font-medium',
          ]}
        >
          {title}
          {_multiple ? `（${choiceList.length}/${maxChoice}）` : ''}
        </div>
        <div className={[
            "h-48px px-12px flex items-center mt-16px mb-16px rounded-12px",
            globalStore.isDark ? 'bg-input-bg-normal border-1px border-solid border-[rgba(255,255,255,0.1)]' : 'bg-[rgba(0,0,0,0.04)]'
          ]}>
          <SVGPureIcon name="icon_search_input" className="size-24px mr-8px" />
          <CompositionInput
            className="h-full !text-16px !p-0 !bg--transparent composition-input-no-border"
            bordered={false}
            id="composition-input"
            placeholder="搜索模型"
            value={wd}
            onChange={handleInputChange}
          />
        </div>
        {
          simple ? null :
          <div className="flex flex-wrap gap-x-12px gap-y-8px">
          {tagList.map(item => {
            const isCur = item.key == tag;
            return (
              <div
                onClick={evt => {
                  getListByTag(item.key, scene, _scene);
                }}
                key={item.key}
                className={[
                  'inline-flex items-center h-30px px-14px flex gap-4px',
                  'bg-button-bg-normal rounded-8px cursor-pointer',
                  '!hover:bg-[rgba(0,0,0,0.06)] hover:border-none hover:px-15px',
                  'border-1px border-solid border-black border-opacity-10',
                  {'border-white':globalStore.isDark},
                  {'!bg-[rgba(0,0,0,0.06)] border-none px-15px': isCur },
                  {'!bg-transparent':!isCur && globalStore.isDark}
                ]}
              >
                <span
                  title={item.title}
                  className={[
                    'relative text-14px text-primary',
                    'after:(content-[attr(title)] text-primary text-opacity-90 absolute left-0 top-0 whitespace-nowrap)',
                    isCur ? 'after:font-medium' : 'after:font-normal' ,
                  ]}
                >
                  {item.title}
                </span>
                {
                  item.type === 100 &&
                  <span className='bg-[#C77FCB] rounded-8px leading-16px px-6px text-white text-center text-12px'>API</span>

                }
              </div>
            );
          })}
        </div>
        }
      </div>
      <div className={['w-full h-full flex flex-col pr-4px pb-13px']}>
        <div
          id={isModal ? 'model_list_wrap_modal' : ''}
          className={[
            isModal ? 'h-0 pb-24px flex-grow nw-scrollbar overflow-y-auto' : '',
            isModal ? 'mt-16px' : 'mt-24px',
          ]}
        >
          <InfiniteScroll
            dataLength={listData?.length}
            next={evt => {
              getList(false,"",_scene);
            }}
            hasMore={!!npt}
            loader={null}
            scrollableTarget={`model_list_wrap_${scene}`}
            className={['', isModal ? '' : 'grid gap-14px grid-cols-2']}
          >
            {listData?.map(item => (
              <ListItem
                modelSearchStore={modelSearchStore}
                {...props}
                multiple={_multiple}
                currentList={currentList}
                key={item.id}
                item={item}
                isModal={isModal}
              />
            ))}
          </InfiniteScroll>
        </div>
      </div>
    </div>
  );
});
export default ModelSearch;
